import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withCookies, Cookies } from 'react-cookie'
import { getThumbnailSVG, RoleStr } from '../Commons/Utils'

export const CategoryStr = {
    REPORT: '작업보고',
    REPORT_COMMENT: '댓글',
    RFI: '요청사항',
    RFI_COMMENT: '댓글',
    RFI_RESPONSE: '요청사항 답변',
    POSTING: '회의록',
    POSTING_COMMENT: '댓글',
}

class NoticeFilter extends Component {
    shouldComponentUpdate(nextProps, nextState) {
        const ret = this.props.item.id !== nextProps.item.id
        return ret
    }

    render() {
        const item = this.props.item
        const clickLink = this.props.clickLink
        const deleteNotice = this.props.deleteNotice

        let thumbnail = ''
        if (item.user.thumbnailUrl) {
            thumbnail = <img src={item.user.thumbnailUrl} alt="profile" />
        } else {
            thumbnail = getThumbnailSVG(item.user.group, 24)
        }

        const newDate = new Date(item.createdAt)

        let newHours = newDate.getHours()
        if (newHours < 10) {
            newHours = '0' + newHours
        }
        let newMinutes = newDate.getMinutes()
        if (newMinutes < 10) {
            newMinutes = '0' + newMinutes
        }

        return (
            <div className={item.isRead ? 'notice_item notice_item_read' : 'notice_item'}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    className="delete_btn"
                    onClick={() => deleteNotice(item._id)}>
                    <g fill="none" fillRule="evenodd" stroke="#D0D5DE" strokeLinecap="round" strokeWidth="1.7">
                        <path d="M1.351 16.877L16.878 1.109M1.351 1.11l15.526 15.767" />
                    </g>
                </svg>
                <div onClick={() => clickLink(item)}>
                    <div className="thumbnail">{thumbnail}</div>
                    <div className="notice_content_wrap">
                        <ul className="user_info pc_v">
                            <li>
                                {RoleStr[item.user.role]} {item.user.name}
                            </li>
                            <li className="line"></li>
                            <li>
                                {newHours}:{newMinutes}
                            </li>
                        </ul>
                        <p className="notice_catagory">{item.project.title}</p>
                        <p className="notice_title">
                            <span className="span_catagory">[{CategoryStr[item.landing.menu]}]</span>
                            <span>‘</span>
                            <span className="text_over">{item.title}</span>
                            <span>’</span> 에 새글이 등록되었습니다.
                        </p>
                        <ul className="user_info mobile_v">
                            <li>
                                {RoleStr[item.user.role]} {item.user.name}
                            </li>
                            <li className="line"></li>
                            <li>
                                {newHours}:{newMinutes}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}

export default withCookies(NoticeFilter)



// WEBPACK FOOTER //
// ./Src/Components/Notice/NoticeFilter.js